exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container-block {\n    padding: 20px 15px 0 15px;\n}\n\n.btn-custom-warning {\n    margin-right: 10px;\n}\n\nagm-map {\n    height: 400px;\n}\n\n\n\n\n.confirm-block {\n    position: absolute;\n    overflow: visible;\n}\n\n.confirm-block  .confirm-sub {\n    position: relative;\n    z-index: 9999;\n    background: white;\n    padding: 4px 35px;;\n    border-radius: 4px;\n}\n\n.modal-white {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 9995;\n    background: rgba(0,0,0,0.3);\n}\n\n.no-float {\n    float: none;\n}\n\n.confirm-block button.btn-custom-danger {\n    padding-left: 31px;\n    padding-right: 31px;\n}\n.confirm-block-r {\n    position: relative;\n    top: -15px;\n    left: -6px;\n}\n\n.top-button-group {\n    display: inline-block;\n}\n\n.top-button-group > label {\n    font-weight: 200;\n    margin: 0;\n    font-size: 0.9em;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/client-forms/client-info/client-info.css
// module id = 1206
// module chunks = 9